import sortBy from 'lodash/sortBy';
import { searchesDeep } from '../selectors/entities';

// TODO: Remove this once the real problem of remounting/rerendering is solved
let cachedUserWatchList;

export const userWatchListItemsSelector = state => {
  const userWatchList = state.entities.searches.userWatchList;

  if (cachedUserWatchList) {
    return cachedUserWatchList;
  }

  if (userWatchList) {
    cachedUserWatchList = getUserWatchListItems(state, userWatchList);
    return cachedUserWatchList;
  }
};

const getUserWatchListItems = (state, userWatchList) => {
  const searchEntities = searchesDeep(state);
  if (!searchEntities.runs) {
    return [];
  }

  const taskAndRunEntities = userWatchList.results.filter(
    entity =>
      (entity.schema === 'tasks' || entity.schema === 'runs') &&
      searchEntities['runs'][entity.id]
  );
  const list = taskAndRunEntities.reduce((watchList, { id, schema: type }) => {
    const entity = searchEntities[type][id];
    if (entity.runID && searchEntities.runs[entity.runID]) {
      const run = searchEntities.runs[entity.runID];
      const process = searchEntities.processes[entity.runID];
      addRunToWatchlist(
        watchList,
        run,
        (process && process.displayName) || run.processDisplayName
      );
    }
    return watchList;
  }, {});

  return sortBy(list, [
    function(o) {
      return o.processDisplayName;
    }
  ]);

  function addRunToWatchlist(watchList, run, processDisplayName) {
    if (!watchList[run.processID]) {
      watchList[run.processID] = {
        processID: run.processID,
        processDisplayName: processDisplayName,
        runs: {}
      };
    }
    watchList[run.processID].runs[run.runID] = {
      displayName: run.displayName,
      percentComplete: run.percentComplete,
      runID: run.runID
    };
  }
};



// WEBPACK FOOTER //
// ./js/UserWatchList/UserWatchListSelectors.js